import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Account } from '@libs/src/models/account.model';

const ACCOUNTS_API_URL = '/api/accounts';
const ACCOUNTS_V2_API_URL = '/api/v2/accounts';

@Injectable({ providedIn: 'root' })
export class AccountsBackend {
  constructor(private http: HttpClient) {}

  getAccount(accountSlug: string) {
    return this.http.get<{ profile: Account }>(
      `${ACCOUNTS_API_URL}/${accountSlug}`,
    );
  }

  getAccounts(params: any) {
    return this.http.get(ACCOUNTS_V2_API_URL, { params });
  }
}
